import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="footer" data-testid="footer">
      <div className="container">
        <div className="footer-content">
          <div>
            <div className="footer-brand">Woodhouse & Archer</div>
            <p className="footer-description">
              Premier talent management and representation for actors, models, and performers. 
              Elevating careers, creating opportunities.
            </p>
            <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem' }}>
              <a 
                href="https://instagram.com/woodhouseandarcher" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                data-testid="footer-instagram"
                title="Follow us on Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/roster">Talent Roster</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="footer-title">For Talent</h4>
            <ul className="footer-links">
              <li><Link to="/register">Apply to Join</Link></li>
              <li><Link to="/admin/login">Talent Login</Link></li>
              <li>
                <a 
                  href="https://instagram.com/woodhouseandarcher" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  @woodhouseandarcher
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Woodhouse & Archer. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
